import { Badge } from "./Card";
import { statusColor } from "../../lib/statusColors";

export function StatusBadge({ status }: { status: string | null | undefined }) {
  if (!status) return null;
  return <Badge label={status.replace(/_/g, " ")} color={statusColor(status)} />;
}
